import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { Box, Button, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useState } from "react";
import { setToStorage, showError, showToast } from "../../helpers";
import { temporaryToken } from "../../reducers/authSlice";
import { STORAGE_KEYS } from "../../constants/storagekeys";
import { OTP_TYPES } from "../../constants/enums";
import { useAppDispatch } from "../../hooks/store";
import { useForgotPasswordMutation, usePostVerifyOtpMutation } from "../../services/auth";
import { USE_FAKE_DATA } from "../../config/appConfig";


const otpStyle: any = {
  width: '50px',
  height: '50px',
  margin: '0 auto',
};

const OtpVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  const [otp, setOtp] = useState<string>("");
  const [countDown, setCountDown] = useState<number>(59);
  const [optVerificationMutation, { isLoading }] = usePostVerifyOtpMutation();
  const [ForgotPasswordMutation] = useForgotPasswordMutation();

  const [error, setError] = useState<boolean>(false);

  const handleResendOtp = async (e: any) => {
    e.preventDefault();
    const body = {
      email: state?.email,
    };
    try {
      if (USE_FAKE_DATA) {
        showToast('OTP Resent Successfully');
        setCountDown(59);
        return;
      }
      const response = await ForgotPasswordMutation(body as any).unwrap();
      if (response?.statusCode === 200) {
        showToast('OTP Resent Successfully');
        setCountDown(59);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      console.log(error);
    }
  };

  const  handleSubmit = async (e: any) => {
    e.preventDefault();
    if (otp?.length === 6) {
        setError(false);

      const body = {
        email: state?.email,
        otp: otp,
        type: OTP_TYPES.FORGET,
      };
       try {
        if (USE_FAKE_DATA) {
          dispatch(temporaryToken({ tempToken: 'fake-temp-token' }));
          setToStorage(STORAGE_KEYS.tempToken, 'fake-temp-token');
          showToast('OTP verified successfully');
          navigate('/reset-password', { replace: true });
          return;
        }
        const response = await optVerificationMutation(body as any).unwrap();
        if (response?.statusCode === 200) {
          dispatch(temporaryToken({ tempToken: response?.data?.token }));
          setToStorage(STORAGE_KEYS.tempToken, response?.data?.token);
          showToast('OTP verified successfully');
          navigate('/reset-password', { replace: true });
        }
      } catch (error: any) {
        if (error?.data?.message) {
          showError(error?.data?.message || '');
        }
      }
    } else {
      setError(true);
    }

    
  };
  
    useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify Email Address</h2>
        <p>
          A verification OTP has been sent to your email. Please check your
          inbox.
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <label htmlFor="otp">Enter OTP</label>
            <div className="opt_fields">
           <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderInput={(props) => <input {...props} />}
            inputStyle={otpStyle}
            inputType="tel"
          />
            </div>
          </div>
          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
              onClick={handleSubmit}
             
            >
              Submit
            </Button>
          </div>
          {countDown === 0 ? (
          <Box
            sx={{
              textAlign: 'center',
              pt: 2,
            }}
          >
            <Typography
              className="anchor_link"
              sx={{
                cursor: 'pointer',
                color: '#9988C5',
                fontWeight: '700',
              }}
              onClick={isLoading ? undefined : handleResendOtp}
            >
              Resend OTP
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography
              // className="anchor_link"
              sx={{
                pt: 2,
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                marginLeft: '-40px',
              }}
            >
              The verification code will expire in{' '}
              
                <span
                  style={{
                    margin: 0,
                    right: 35,
                    position: 'absolute',
                  }}
                >
                  {`00 : ${countDown < 10 ? '0' : ''}${countDown}`}
                </span>
            </Typography>
          </Box>
        )}
        </form>
        <div className="auth_bottom">
          <p>
            <button className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
